export default __webpack_public_path__ + "static/media/moluscos.96760234.svg";